var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_buscar",
    "data-name": "ico buscar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.281,
    height: 14.28,
    viewBox: "0 0 14.281 14.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c6c6c6;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_689",
    "data-name": "Trazado 689",
    className: "cls-1",
    d: "M378.288,46.277a5.82,5.82,0,1,0-1.809,1.8l3.707,3.707,1.808-1.809Zm-4.841.14a3.185,3.185,0,1,1,3.185-3.185A3.186,3.186,0,0,1,373.447,46.417Z",
    transform: "translate(-367.714 -37.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.81cfa7a3e8c177d32dc9208edb7d8281.svg";
export { ForwardRef as ReactComponent };